import { render } from "./AddNewProviderReferralNoteOverlay.vue?vue&type=template&id=0366db37&scoped=true&lang=pug"
import script from "./AddNewProviderReferralNoteOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewProviderReferralNoteOverlay.vue?vue&type=script&lang=js"

import "./AddNewProviderReferralNoteOverlay.vue?vue&type=style&index=0&id=0366db37&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366db37"]])

export default __exports__